import { CanvasLayer }  from '@pdf-tools/four-heights-pdf-web-viewer/es6/modules/CanvasLayer';
import { CursorStyle }  from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-canvas/state/viewer';
import { Color } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/Color';
import { ViewerCanvasState } from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-canvas/state/store';
import {
  createCustomEditShapeAnnotationToolbar
} from './CustomEditShapeAnnotationToolbar';


const moduleLayerName = 'CustomEditShapeAnnotation';
export class CustomEditShapeAnnotationLayer extends CanvasLayer {
  private shapeAnnotation: any;
  private context: any;
  private toolbar: any;
  private strokeColors:any[];
  private fillColors:any[];
  constructor() {
    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    this.shapeAnnotation = null;
    this.context = null;
    this.toolbar = null;
    this.strokeColors = [];
    this.fillColors = [];
  }
  onCreate(annotationId: number) {
    this.shapeAnnotation = this.pdfApi.getItem(annotationId);
    this.setStrokeColor = this.setStrokeColor.bind(this);
    this.setStrokeWidth = this.setStrokeWidth.bind(this);
    this.setStrokeStyle = this.setStrokeStyle.bind(this);
    this.setFillColor = this.setFillColor.bind(this);
    this.close = this.close.bind(this);
    const annotOptions = this.options.annotation;
    this.strokeColors = annotOptions.colors.foregroundColors;
    this.fillColors = annotOptions.colors.backgroundColors;
    this.context = this.createCanvas();
    /* tslint:disable-next-line:align */
    // @ts-ignore
    const toolbarElement = this.module.toolbarElement;
    this.toolbar = createCustomEditShapeAnnotationToolbar({
      strokeColors: this.strokeColors,
      strokeWidths: annotOptions.strokeWidths,
      fillColors: this.fillColors,
      selectedStrokeColor: this.shapeAnnotation.color
        ? this.shapeAnnotation.color
        : annotOptions.colors.shapeColor,
      selectedStrokeWidth: this.shapeAnnotation.border.width,
      selectedStrokeStyle: this.shapeAnnotation.border.style,
      selectedFillColor: this.shapeAnnotation.fillColor
        ? this.shapeAnnotation.fillColor
        : annotOptions.colors.shapeFillColor,
      itemType: this.shapeAnnotation.itemType,
      onStrokeColorChanged: this.setStrokeColor,
      onStrokeWidthChanged: this.setStrokeWidth,
      onStrokeStyleChanged: this.setStrokeStyle,
      onFillColorChanged: this.setFillColor,
      onCancel: this.close,
    }, toolbarElement);
    this.store.viewer.beginModule(moduleLayerName);
  }
  close() {
    this.remove();
  }
  onSave() {
    const promise = new Promise<void>((resolve, reject) => {
      resolve();
    });
    return promise;
  }
  onRemove() {
    this.removeCanvasElements();
    this.context = null;
    /* tslint:disable-next-line:align */
    // @ts-ignore
    const toolbarElement = this.module.toolbarElement;
    toolbarElement.innerHTML = '';
    this.store.viewer.setCursorStyle(CursorStyle.DEFAULT);
    this.store.viewer.endModule(moduleLayerName);
  }
  render(timestamp: number, state: ViewerCanvasState) {
    var _a;
    if (state.viewer.modeChanged && state.viewer.selectedModuleName !== moduleLayerName) {
      this.remove();
      return;
    }
    if (state.pointer.action === 'click' || state.pointer.action === 'dblclick') {
      const shapeAnnotation = (_a = this.pdfApi
        .getAnnotationsOnPoint({
          x: state.pointer.x.devicePixels,
          y: state.pointer.y.devicePixels,
        })) === null || _a === void 0 ? void 0 : _a.find((a) => this.shapeAnnotation && a.id === this.shapeAnnotation.id);
      if (!shapeAnnotation) {
        this.close();
        return;
      }
    }
    if (this.context && this.shapeAnnotation) {
      const ctx = this.context;
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
      const rect = this.pdfApi.transformPdfPageRectToScreenRect(this.shapeAnnotation.pdfRect);
      const lineWidth = 2 * devicePixelRatio;
      ctx.save();
      ctx.strokeStyle = this.options.viewer.general.textSelectionColor;
      ctx.lineWidth = lineWidth;
      ctx.setLineDash([lineWidth, lineWidth]);
      ctx.strokeRect(rect.x - lineWidth, rect.y - lineWidth, rect.w + 2 * lineWidth, rect.h + 2 * lineWidth);
      ctx.restore();
    }
  }
  setStrokeColor(color:any) {
    if (this.shapeAnnotation && this.shapeAnnotation.color) {
      const newColor = new Color(color);
      const currentColor = new Color(this.shapeAnnotation.color);
      newColor.setOpacity(currentColor.a);
      this.shapeAnnotation.color = newColor.toRgba();
      this.updateShapeAnnotation();
    }
  }
  setStrokeWidth(width:any) {
    if (this.shapeAnnotation) {
      this.shapeAnnotation.border = {
        style: this.shapeAnnotation.border.style,
        width: width,
      };
      this.updateShapeAnnotation();
    }
  }
  setStrokeStyle(style:any) {
    if (this.shapeAnnotation) {
      this.shapeAnnotation.border = {
        style: style,
        width: this.shapeAnnotation.border.width,
      };
      this.updateShapeAnnotation();
    }
  }
  setFillColor(color:any) {
    if (this.shapeAnnotation) {
      const newColor = new Color(color);
      this.shapeAnnotation.fillColor = newColor.toRgba();
      this.updateShapeAnnotation();
    }
  }
  updateShapeAnnotation() {
    const promise = new Promise((resolve, reject) => {
      if (this.pdfApi && this.shapeAnnotation) {
        this.pdfApi
          .updateItem(this.shapeAnnotation)
           .then((item) => {
            resolve(item);
          })
          .catch((error) => {
            console.warn(error);
          });
      }
      else {
        reject();
      }
    });
    return promise;
  }
}
